


// 存储城市列表的数据
const cityList = {
  namespaced: true,
  state: {
    // 排列过的城市列表数据
    cityList: {},
    // 当前自动定位的城市名
    localCity: '',
    // 用户选择的城市名
    cityName: '',
    // 用户选择的城市code
    cityCode: '',
    // 用户选择的影院数据
    cinemaInfo: {
      cinemaCode: '',
      cinemaName: '',
      cinemaAdress: ''
    }
  },
  mutations: {
    setCityList (state, payload) {
      state.cityList = payload
    },
    setLocalCity (state, payload) {
      state.localCity = payload
    },
    setCityInfo (state, payload) {
      state.cityName = payload
    },
    setCityCode (state, payload) {
      state.cityCode = payload
    },
    setCinemaInfo (state, payload) {
      state.cinemaInfo = payload
    }
  },
  actions: {
    async setCityList (context, payload) {
      try {
       // let res = await getCinemaInfoList()
       // context.commit('setCityList', res.data || [])
        
      
      
      } catch (e) {
        console.error('城市列表', e)
      }
    },
    setLocalCity (context, payload) {
      context.commit('setLocalCity', payload)
    },
    setCityInfo (context, payload) {
      context.commit('setCityInfo', payload)
    },
    setCityCode (context, payload) {
      context.commit('setCityCode', payload)
    },
    setCinemaInfo (context, payload) {
      context.commit('setCinemaInfo', payload)
    }
  }
}

export default cityList



// WEBPACK FOOTER //
// ./src/store/buyTicket/cityList.js